
import { Vote, BarChart3, Users } from "lucide-react";
import FeatureCard from "@/components/cayman/FeatureCard";

const PostElectionSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-5xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          The Election is Just the Beginning
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-3xl mx-auto">
          The Cayman Islands general election on April 30th, 2025 marked an important moment 
          for democracy. But the real work of civic engagement happens between elections.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard 
            title="Stay Engaged" 
            description="Regular polls and insights on key issues affecting the Cayman Islands, from infrastructure to environmental policy."
            icon={Vote} 
          />
          
          <FeatureCard 
            title="Track Promises" 
            description="Hold elected officials accountable by tracking their campaign promises against actual performance."
            icon={BarChart3} 
          />
          
          <FeatureCard 
            title="Community Voice" 
            description="Join a community of engaged citizens making their voices heard on decisions that matter to Caymanians."
            icon={Users} 
          />
        </div>
      </div>
    </section>
  );
};

export default PostElectionSection;
